import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./style.css";
import HeroImg from "../images/hero_img.png";
import LogoAlfaInvest from "../images/logo_alfa_invest.png";
import LogoGross from "../images/logo_gross.png";
import LogoInson from "../images/logo_inson.png";
import LogoMyInsurance from "../images/logo_my_insurance.png";

export const Hero = () => {
    const [govNumber, setGovNumber] = useState("");
    const [techPassportSeria, setSeria] = useState("");
    const [techPassportNumber, setNumber] = useState("");
    const navigate = useNavigate();

    const serialRef = useRef(null);
    const numberRef = useRef(null);

    const handleSubmit = () => {
        if (!govNumber || !techPassportSeria || !techPassportNumber) {
            alert("Пожалуйста, заполните все поля");
            return;
        }

        navigate("/vehicle-info", {
            state: {
                govNumber,
                techPassportSeria,
                techPassportNumber,
            },
        });
    };

    return (
        <div className="hero">
            <div className="hero-content">
                <div className="hero-texts">
                    <p className="hero-title">
                        КАСКО ОНЛАЙН <br />
                        <span className="highlight">+ ПОДАРОК</span>
                    </p>
                    <p className="hero-subtitle">
                        Получите дорожную карту помощи на дороге <br />
                        при оформлении КАСКО
                    </p>

                    <div className="hero-form-line">
                        <div className="input-group">
                            <div className="serial-wrapper">
                                <div className="input-wrapper">
                                    <label>
                                        гос номер <span>*</span>
                                    </label>
                                    <input
                                        className="input-field input-field-gos-number"
                                        type="text"
                                        placeholder="01 A 123 AA"
                                        value={govNumber}
                                        onChange={(e) => {
                                            let value = e.target.value.toUpperCase();
                                            value = value.replace(/[^A-Z0-9\s]/g, "");
                                            setGovNumber(value);

                                            if (value.length >= 8 && serialRef.current) {
                                                serialRef.current.focus();
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="serial-wrapper">
                                <div className="input-wrapper">
                                    <label>
                                        серия <span>*</span>
                                    </label>
                                    <input
                                        ref={serialRef}
                                        className="input-field input-field-serial"
                                        type="text"
                                        placeholder="AAA"
                                        value={techPassportSeria}
                                        onChange={(e) => {
                                            const value = e.target.value
                                                .toUpperCase()
                                                .replace(/[^A-Z]/g, "");
                                            setSeria(value);

                                            if (value.length >= 3 && numberRef.current) {
                                                numberRef.current.focus();
                                            }
                                        }}
                                    />
                                </div>

                                <div className="input-wrapper">
                                    <label>
                                        номер <span>*</span>
                                    </label>
                                    <input
                                        ref={numberRef}
                                        className="input-field input-field-serial-number"
                                        type="text"
                                        placeholder="1234567"
                                        value={techPassportNumber}
                                        onChange={(e) =>
                                            setNumber(e.target.value.replace(/[^0-9]/g, ""))
                                        }
                                    />
                                </div>
                            </div>

                            <button className="hero-button" onClick={handleSubmit}>
                                Рассчитать
                            </button>
                        </div>
                    </div>
                </div>

                <img className="hero-image" src={HeroImg} alt="car" />
            </div>

            <div className="logos-row">
                <img src={LogoAlfaInvest} alt="Alfa Invest" />
                <img src={LogoGross} alt="Gross" />
                <img src={LogoInson} alt="Inson" />
                <img src={LogoMyInsurance} alt="My Insurance" />
            </div>
        </div>
    );
};
